import React, { useEffect, useState } from "react";
import DatePickerField from "../../../common/components/FormFields/DatePickerField";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import { useForm, useFormContext } from "react-hook-form";
import InputField from "../../../common/components/FormFields/InputField";
import InputArea from "../../../common/components/FormFields/InputArea";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import { useEMRContext } from "./EMRContextGync";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import CreateableSelect from "../../../common/components/FormFields/CreateableSelect";
import { getEDDDate } from "../services/GynacEmr/GynacEmr";
import { format, isValid } from "date-fns";
// import CreateableSelect from "../../../common/components/FormFields/CreateableSelect";

export default function GynacObstetricDetails(props) {
  const { ancChecked, setAncChecked } = useEMRContext();
  const [conceptionDate, setConceptionDate] = useState(null);
  const [eddDate, setEddDate] = useState(null);

  const modeOfDeliveryType = [
    {
      id: 1,
      label: "Normal",
      value: "Normal",
    },
    {
      id: 2,
      label: "Cesarean",
      value: "Cesarean",
    },
    {
      id: 3,
      label: "Abortion",
      value: "Abortion",
    },
    {
      id: 4,
      label: "Ectopic",
      value: "Ectopic",
    },
    {
      id: 5,
      label: "Instrumental",
      value: "Instrumental",
    },
    {
      id: 6,
      label: "Present",
      value: "Present",
    },
  ];
  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
    // defaultValues,
  });

  const { divData, setDivData, isDirty, setIsDirty } = useEMRContext();
  const [presentvalue, setPresentValue] = React.useState(0);
  const [isPregnant, gravida, cycleLength, present] = watch([
    "isPregnant",
    "gravida",
    "cycleLength",
  ]);
  console.log("gravida", gravida);
  const [count, setCount] = useState(gravida + presentvalue);
  const [gravidaValue, setGravida] = useState("");
  const [para, setPara] = useState("");

  const handleChange = (e) => {
    const value = parseInt(e.target.value); // Parse input value to an integer
    setCount(value); // Update the count state with the input value
  };

  // Update divData whenever count changes
  useEffect(() => {
    const newData = Array.from(
      { length: Number(gravida) + Number(presentvalue) },
      (_, index) => {
        if (divData[index]) {
          // If the index exists in divData, return its values
          return { ...divData[index] };
        } else {
          // Otherwise, initialize new values
          return {
            modeOfDelivery: "",
            gender: "",
            age: "",
            otherInfo: "",
          };
        }
      }
    );
    setDivData(newData);
  }, [gravida, presentvalue]);

  // Update specific field in divData
  const updateDivData = (index, field, value) => {
    setDivData((prevData) => {
      const newData = [...prevData];
      newData[index][field] = value;
      return newData;
    });
  };

  const handleButtonClick = (label, index) => {
    setDivData((prevData) => {
      return prevData.map((item, i) => {
        if (i === index) {
          return { ...item, gender: label };
        }
        return item;
      });
    });
  };
  let anc = watch("anc");

  let lmp = watch("lmp");
  console.log("ancancancanc", anc);
  // Calculate Conception date and EDD based on LMP
  useEffect(() => {
    // Watch the cycle length

    if (lmp && cycleLength) {
      const conceptionOffset = (cycleLength - 14) * 24 * 60 * 60 * 1000; // Adjust based on cycle length
      const conception = new Date(lmp.getTime() + conceptionOffset); // Adjusted conception date
      const edd = new Date(lmp.getTime() + 280 * 24 * 60 * 60 * 1000); // Add 280 days for EDD

      setConceptionDate(conception);
      setEddDate(edd);
      console.log("conceptiontoISOString", conception, edd);
      setValue("conception", conception);
      setValue("edd", edd);
      if (edd !== null && edd !== undefined) {
        setValue("isPregnant", true);
      }
    }
  }, [watch("lmp"), watch("cycleLength")]); // Add cycleLength to the dependencies

  // const calculateEDD = (lmp, cycleLength) => {
  //   const cycleAdjustment = cycleLength - 28;
  //   const edd = new Date(lmp);
  //   edd.setDate(edd.getDate() + 280 + cycleAdjustment);
  //   return edd;
  // };

  // const calculateConceptionDate = (lmp, cycleLength) => {
  //   const cycleAdjustment = cycleLength - 28;
  //   const conceptionDate = new Date(lmp);
  //   conceptionDate.setDate(conceptionDate.getDate() + 14 + cycleAdjustment);
  //   return conceptionDate;
  // };
  // useEffect(() => {
  //   if (lmp && cycleLength) {
  //     if (cycleLength <= 21 || cycleLength >= 40) {
  //       warningAlert("Please Fill Correct Cycle Length");
  //       setValue("edd", null);
  //       setValue("conception", null);
  //     } else {
  //       const edd = calculateEDD(lmp, cycleLength);
  //       const conceptionDate = calculateConceptionDate(lmp, cycleLength);
  //       setValue("conception", conceptionDate);

  //       setValue("edd", edd);
  //       console.log("edd99", edd);
  //     }
  //   }
  // }, [lmp, cycleLength]);

  let yesWatch = watch("yes");
  console.log("yesWatch", yesWatch);
  let noWatch = watch("no");
  // useEffect(()=>{
  //    if(yesWatch  === true)
  //    {
  //     setValue("no",false)
  //    }else if(noWatch === true){
  //     setValue("yes",false)
  //    }
  // },[yesWatch,noWatch])

  const validatePara = (value) => {
    // Perform validation logic for 'para' field
    // For example, ensure it's not greater than 'gravida'

    console.log("gravidaValue", value);
    return value <= gravidaValue || "Para must not be greater than Gravida";
  };
  const [lmpCal, setLMPCal] = useState(null);
  console.log("lmp", lmp);

  useEffect(() => {
    if (lmp !== null && lmp !== undefined && lmp !== "Invalid Date") {
      console.log("LMPDate", lmp);

      let LMPDate;
      if (lmp && isValid(lmp)) {
        LMPDate = format(lmp, "yyyy-MM-dd");
      }

      let obj = {
        lmpDate: LMPDate,
        isEt: props.editData?.isEt,
      };
      getEDDDate(obj).then((response) => {
        setLMPCal(response.data.result);
      });
    }
  }, [props.editData, lmp]);
  console.log("response7474", lmpCal);
  useEffect(() => {
    if (lmpCal?.gestationalAgeWeeks !== null) {
      setValue("eddbyNT", lmpCal?.gestationalAgeWeeks);
    }
    if (isPregnant === true) {
      if (lmpCal?.edd !== null && lmpCal?.edd !== undefined) {
        const [day, month, year] = lmpCal?.edd.split("-");

        const date = new Date(`${year}-${month}-${day}`);
        console.log("edd4141", date);

        setValue("edd", date);
      }
    }
  }, [lmpCal, isPregnant]);

  React.useEffect(() => {
    if (isPregnant === true && !Number(cycleLength) > 0) {
      warningAlert("Please enter valid cycle length .");
    }
  }, [isPregnant]);

  return (
    <div>
      <div className="flex justify-between bg-[#FEDFDB] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">Obstetric Details</p>
      </div>
      <div className="grid xl:grid-cols-4 overflow-visible lg:grid-cols-2 md:grid-cols-2 gap-2 p-2 border h-50 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        {anc === false || anc === undefined ? (
          <div className="">
            <fieldset
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <DatePickerField
                control={control}
                name="lmp"
                label="LMP"
                inputFormat="dd-MM-yyyy"
                disableFuture
                disabled={props.pastData !== null}
              />
            </fieldset>
          </div>
        ) : (
          ""
        )}
        <div>
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <DatePickerField
              control={control}
              name="conception"
              label="Conception"
              inputFormat="dd-MM-yyyy"
              disabled={props.pastData !== null}
            />
          </fieldset>
        </div>
        <div className="flex space-x-1">
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault();
              }
            }}
          >
            <InputField
              control={control}
              name="cycleLength"
              label="Cycle Length"
              type="number"
              error={errors.cycleLength}
              disabled={props.pastData !== null}
            />
          </fieldset>
          <fieldset
            className="whitespace-nowrap"
            onChange={(e) => {
              setValue("isPragnant", e?.target?.checked);
            }}
          >
            <CheckBoxField
              control={control}
              name={"isPregnant"}
              label={"Is Pregnant"}
            />
          </fieldset>
        </div>

        {anc === false || anc === undefined ? (
          <div>
            <fieldset
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <DatePickerField
                control={control}
                name="edd"
                label="EDD"
                inputFormat="dd-MM-yyyy"
                disabled
              />
            </fieldset>
          </div>
        ) : (
          ""
        )}

        <div className="flex space-x-1">
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault();
              }
            }}
          >
            <InputField
              disabled={props.pastData !== null}
              control={control}
              name="gravida"
              label="Gravida"
              type="number"
              inputRef={{
                ...register("gravida", {
                  onChange: (e) => {
                    console.log("temperature555", e.target.value);
                    if (Number(e.target.value) > 100) {
                      console.log("isDirty777", isDirty);
                      setIsDirty(true);
                    } else {
                      setIsDirty(false);
                    }
                  },
                }),
              }}
              error={
                watch("gravida") > 100 ? { message: "Wrong Pulse Rate" } : null
              }
            />
          </fieldset>
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <InputField
              control={control}
              name={"present"}
              label={"Present"}
              inputRef={{
                ...register("present", {
                  onChange: (e) => {
                    setPresentValue(e?.target?.value);
                  },
                }),
              }}
            />
          </fieldset>
        </div>
        <div className="flex space-x-1 ">
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <InputField
              disabled={props.pastData !== null}
              control={control}
              value={para}
              name="para"
              type="number"
              label="Para"
              inputRef={{
                ...register("para", {
                  onChange: (e) => {
                    console.log("temperature555", e.target.value);
                    if (Number(e.target.value) > watch("gravida")) {
                      console.log("isDirty777", isDirty);
                      setIsDirty(true);
                    } else {
                      setIsDirty(false);
                    }
                  },
                }),
              }}
              error={
                watch("para") > watch("gravida")
                  ? { message: "Wrong Pulse Rate" }
                  : null
              }
            />
          </fieldset>
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <InputField
              disabled={props.pastData !== null}
              control={control}
              type="number"
              name="living"
              label="Living"
            />
          </fieldset>
        </div>

        <div className="flex space-x-1">
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <InputField
              disabled={props.pastData !== null}
              control={control}
              type="number"
              name="abortion"
              label="Abortion"
            />
          </fieldset>
          <div className="flex space-x-2">
            <div className="">
              <label className="font-semibold text-sm ">Lactating </label>
            </div>
            <div className="font-semibold text-sm ">:</div>
            <fieldset
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              className="-mt-2"
              onChange={(e) => {
                if (e.target.checked === true) {
                  setValue("no", false);
                }
              }}
              disabled={props.pastData !== null}
            >
              <CheckBoxField control={control} name="yes" label="Yes" />
            </fieldset>
          </div>
        </div>
        <div>
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            className="-mt-2"
            onChange={(e) => {
              if (e.target.checked === true) {
                setValue("yes", false);
              }
            }}
            disabled={props.pastData !== null}
          >
            <CheckBoxField control={control} name="no" label="No" />
          </fieldset>
        </div>
        <fieldset
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <InputField
            disabled={props.pastData !== null}
            control={control}
            name="lastChildBirth"
            label="Last Child Birth"
          />
        </fieldset>
        <div className="xl:col-span-4 lg:col-span-2">
          {divData.map((item, index) => {
            if (
              item.modeOfDelivery !== null &&
              item.modeOfDelivery !== undefined
            ) {
              setValue(
                `modeOfDelivery${index}`,
                item.modeOfDelivery !== null &&
                  item.modeOfDelivery !== undefined &&
                  item?.modeOfDelivery !== ""
                  ? {
                      label: item.modeOfDelivery,
                      value: item.modeOfDelivery,
                    }
                  : null
              );
            }
            console.log("itemitem", item);
            let patchDeliveryMode = modeOfDeliveryType.filter(
              (val) => val?.label === item.modeOfDelivery
            );
            return (
              <div className="w-full" key={index}>
                <div className="flex space-x-2 py-2">
                  <div className="w-[20%]">
                    <fieldset
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    >
                      <CreateableSelect
                        isDisabled={props.pastData === true}
                        control={control}
                        name={`modeOfDelivery${index}`}
                        placeholder={`(G ${index + 1}) Mode Of Delivery`}
                        dataArray={modeOfDeliveryType}
                        inputRef={{
                          ...register(`modeOfDelivery${index}`, {
                            onChange: (e) => {
                              console.log(e.target.value.id);
                              updateDivData(
                                index,
                                "modeOfDelivery",
                                e.target.value.value
                              );
                            },
                          }),
                        }}
                      />
                    </fieldset>
                  </div>
                  <div className="flex space-x-2 mt-1 ">
                    <fieldset
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    >
                      <button
                        type="button"
                        disabled={props.pastData !== null}
                        className="border text-center font-semibold w-[25px] h-[25px] rounded-full"
                        onClick={() => handleButtonClick("M", index)}
                        style={{
                          backgroundColor:
                            divData[index]?.gender === "M"
                              ? "red"
                              : "transparent",
                          color:
                            divData[index]?.gender === "M" ? "white" : "red",
                          border: divData[index]?.gender === "M" ? "Red" : "",
                        }}
                      >
                        M
                      </button>
                    </fieldset>
                    <fieldset
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    >
                      <button
                        type="button"
                        disabled={props.pastData !== null}
                        className="border text-center font-semibold w-[25px] h-[25px] rounded-full"
                        onClick={() => handleButtonClick("F", index)}
                        style={{
                          backgroundColor:
                            divData[index]?.gender === "F"
                              ? "green"
                              : "transparent",
                          color:
                            divData[index]?.gender === "F" ? "white" : "green",
                        }}
                      >
                        F
                      </button>
                    </fieldset>
                  </div>
                  <div className="w-[10%]">
                    <fieldset
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                      className=""
                    >
                      <InputField
                        disabled={props.pastData !== null}
                        control={control}
                        type="number"
                        defaultValue={item?.age}
                        name={`age${index}`}
                        label="Age"
                        inputRef={{
                          ...register(`age${index}`, {
                            onChange: (e) => {
                              console.log(" e.target.value", e.target.value);
                              updateDivData(index, "age", e.target.value);
                            },
                          }),
                        }}
                      />
                    </fieldset>
                  </div>
                  <div className="w-full">
                    <fieldset
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    >
                      <InputField
                        disabled={props.pastData !== null}
                        control={control}
                        name={`otherInfo${index}`}
                        defaultValue={item?.otherInfo}
                        label="Other Info."
                        inputRef={{
                          ...register(`otherInfo${index}`, {
                            onChange: (e) => {
                              console.log(e.target.value.id);
                              updateDivData(index, "otherInfo", e.target.value);
                            },
                          }),
                        }}
                      />
                    </fieldset>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div
          className={`${
            anc === true ? "col-span-4" : "xl:col-span-4 lg:col-span-1"
          }`}
        >
          <InputArea
            disabled={props.pastData !== null}
            name="otherHistory"
            placeholder="Other History"
            label="Other History"
            control={control}
          />
        </div>
      </div>
    </div>
  );
}

